import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  sectionControls: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: 14,
    marginTop: 30,
    '& button': {
      width: '100%'
    }
  }
})

export default useStyles
